import intlResource, { DEFAULT_LOCALE, locales } from '../../intl/intlResource';
import {
  fetchLocaleError,
  fetchLocaleRequest,
  fetchLocaleSuccess,
  initLocale,
} from '../../intl/intlSlice';
import { type SupportedLocale } from '../../intl/intlTypes';
import LocaleNegotiator from '../../intl/localeNegotiator';
import { startAppListening } from '../listenerMiddleware';

export const localeListener = () => {
  startAppListening({
    actionCreator: initLocale,
    effect: async (_, { dispatch }) => {
      const locale = LocaleNegotiator.lookup(
        intlResource.getBrowserLocale(),
        locales,
        DEFAULT_LOCALE,
      ) as SupportedLocale;

      dispatch(fetchLocaleRequest(locale));
    },
  });

  startAppListening({
    actionCreator: fetchLocaleRequest,
    effect: async (action, { dispatch }) => {
      try {
        const locale = await intlResource.fetchLocale(action.payload.locale);
        dispatch(fetchLocaleSuccess(locale));
      } catch (error) {
        dispatch(fetchLocaleError(error));
      }
    },
  });
};
